var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jsoneditor-container.max-box[data-v-7be2d28e]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:10000}.jsoneditor-container.min-box[data-v-7be2d28e]{position:relative;min-width:300px;width:100%}.jsoneditor-box[data-v-7be2d28e]{height:100%}.jsoneditor-container:hover .max-btn[data-v-7be2d28e]{display:block}.max-btn[data-v-7be2d28e]{display:none;position:absolute;top:7px;right:110px;color:#fff;width:24px;height:24px;background:transparent url(" + escape(require("./assets/plus.svg")) + ") no-repeat;background-position:3px;border:1px solid transparent;border-radius:3px}.max-btn[data-v-7be2d28e]:hover{border:1px solid #d7e6fe}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7be2d28e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/VueJsoneditor.vue
// module id = 8
// module chunks = 0